module.exports = { "default": require("core-js/library/fn/json/stringify"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /Users/andrewkahn/.nvm/versions/node/v6.10.1/lib/~/vue-cli/~/babel-runtime/core-js/json/stringify.js
// module id = 51
// module chunks = 0